import { render } from "./GlobalSearchID.vue?vue&type=template&id=316e1219"
import script from "./GlobalSearchID.vue?vue&type=script&lang=js"
export * from "./GlobalSearchID.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__